<div class="detail-header"
     [class.bottom-border]="bottomBorder"
     data-testid="schedule-detail-header-container">
  <div class="top-row-container">
    <div class="detail-header-lead">

      <button type="button"
              class="detail-header-back-labeled"
              (click)="backToAreaPage()"
              [attr.aria-label]="'Back to ' + backLabel"
              data-testid="schedule-detail-header-btn-back">
        <i class="pi pi-chevron-right detail-header-back-chevron"
           aria-hidden="true"></i>
        <span class="detail-header-back-text">{{ backLabel || 'Back' }}</span>
      </button>
    </div>
    <div class="detail-header-title">
      <p class="detail-header-address"
         data-testid="schedule-detail-header-title">{{title}}</p>
    </div>
    <div class="detail-header-right">
      <ng-content select="[header-right]"></ng-content>
      @if (showCloud) {
        <online-indicator></online-indicator>
      }
    </div>
  </div>
  @if (subtitle!==undefined) {
    <div class="bottom-row-container">
      @if (subtitle) {
        <p class="detail-header-community"
           data-testid="schedule-detail-header-subtitle">{{subtitle}}</p>
      } @else {
        <p-skeleton width="12rem"></p-skeleton>
      }
    </div>
  }
</div>
@if (showBackgroundRefreshBar) {
  <div class="app-background-refresh-indicator-wrapper">
    <app-background-refresh-indicator [active]="isRefreshingInBackground" />
  </div>
}